
import {defineComponent, PropType} from 'vue';

interface Data {
    [key: string]: any;
}

export default defineComponent({
    name: 'ProfileSelect',
    props: {
        modelValue: {
            type: String as PropType<string>,
            required: true,
        },
        label: {
            type: String as PropType<string>,
            required: false,
            default: null,
        },
        data: {
            type: Object as PropType<Data>,
            required: false,
            default: () => ({}),
        },
    },
    setup(props, {emit}) {
        const updateValue = (event: Event) => {
            const target = event.target as HTMLInputElement;
            emit('update:modelValue', target.value);
        };

        return {
            updateValue,
        };
    },
});
